<style>
#app {
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 18px;
}
.headersearchbox {
  width: 100vw;
  height: 50px;
  display: flex;
  align-items: center;
  /*background: red;*/
  background-color: #d9d9d9;
}
.mint-searchbar-core {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border: 0 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 100% !important;
  outline: 0 !important;
}

element.style {
}
input[type="search"] {
  /* font-size: 16px; */
  /* -webkit-box-sizing: border-box; */
  /* box-sizing: border-box; */
  /* height: 34px; */
  /* text-align: center; */
  /* border: 0; */
  /* border-radius: 6px; */
  /* background-color: rgba(0,0,0,.1); */
}
input[type="color"],
input[type="date"],
input[type="datetime-local"],
input[type="datetime"],
input[type="email"],
input[type="month"],
input[type="number"],
input[type="password"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="time"],
input[type="url"],
input[type="week"],
select,
textarea {
  /* line-height: 21px; */
  /* width: 100%; */
  /* height: 40px; */
  /* margin-bottom: 15px; */
  /* padding: 10px 15px; */
  /* -webkit-user-select: text; */
  /* border: 1px solid rgba(0,0,0,.2); */
  /* border-radius: 3px; */
  /* outline: 0; */
  /* background-color: #fff; */
  /* -webkit-appearance: none; */
}
.mint-searchbar-core {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border: 0 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 100% !important;
  outline: 0 !important;
}
.mint-searchbar-core {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  outline: 0;
}
input,
select,
textarea {
  font-family: "Helvetica Neue", Helvetica, sans-serif !important;
  font-size: 17px !important;
  -webkit-tap-highlight-color: transparent !important;
  -webkit-tap-highlight-color: transparent !important;
}
input {
  line-height: normal !important;
  text-align: start !important;
  background: #fff !important;
  padding: 1px 2px !important;
}
button,
input,
optgroup,
select,
textarea {
  font: inherit !important;
  margin: 0 !important;
  margin-top: 0px !important;
  margin-right: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 0px !important;
  color: inherit !important;
}
</style>

<template>
  <div id="app" style="padding: 0 !important; margin: 0 !important">
    <div class="headersearchbox">
      <mt-search style="width: 100vw" v-model="searchValue"></mt-search>
    </div>

    <!--    第一个选项框，选取的是区域位置-->
    <div class="select-home-class" style="">
      <div class="module-list-wrap areaType">
        <div @click="getpopupVisible('area')">{{ area }}</div>
        <mt-popup
          v-model="areaPopupVisible"
          popup-transition="popup-fade"
          position="bottom"
          @touchmove.native.stop.prevent
        >
          <div class="picker-toolbar-title">
            <div
              class="usi-btn-cancel"
              @click="areaPopupVisible = !areaPopupVisible"
            >
              取消
            </div>
            <div class="">区域选择</div>
            <div class="usi-btn-sure" @click="addrConfirm('area')">确定</div>
          </div>
          <mt-picker
            ref="picker"
            :slots="areaList"
            value-key="name"
            @change="onAreaValuesChange"
          ></mt-picker>
        </mt-popup>
      </div>
      <!--    第二个选项框，选取的是建筑类型-->
      <div class="module-list-wrap buildType">
        <div @click="getpopupVisible('build')">{{ build }}</div>
        <mt-popup
          v-model="buildPopupVisible"
          popup-transition="popup-fade"
          position="bottom"
          @touchmove.native.stop.prevent
        >
          <div class="picker-toolbar-title">
            <div
              class="usi-btn-cancel"
              @click="buildPopupVisible = !buildPopupVisible"
            >
              取消
            </div>
            <div class="">建筑类型</div>
            <div class="usi-btn-sure" @click="addrConfirm('build')">确定</div>
          </div>
          <mt-picker
            ref="picker"
            :slots="buildTypeList"
            value-key="name"
            @change="onBuildValuesChange"
          ></mt-picker>
        </mt-popup>
      </div>

      <!--    第三个选项框，选取的是距离-->
      <!--      <div class="module-list-wrap rangeType">-->
      <!--        <div @click="getpopupVisible('range')">{{ range }}</div>-->
      <!--        <mt-popup v-model="rangePopupVisible" popup-transition="popup-fade" position="bottom"  @touchmove.native.stop.prevent>-->
      <!--          <div class="picker-toolbar-title">-->
      <!--            <div class="usi-btn-cancel" @click="rangePopupVisible = !rangePopupVisible">取消</div>-->
      <!--            <div class="">距离选择</div>-->
      <!--            <div class="usi-btn-sure" @click="addrConfirm('range')">确定</div>-->
      <!--          </div>-->
      <!--          <mt-picker ref='picker' :slots="rangeTypeList" value-key='name' @change="onRangeValuesChange"></mt-picker>-->
      <!--        </mt-popup>-->
      <!--      </div>-->
    </div>
    <!--    一级建筑类型-->
    <div
      class="mui-table-div"
      ref="mui-table-div"
      :style="{ height: wrapperHeight + 'px' }"
    >
      <mt-loadmore
        :bottom-method="loadBottom"
        @bottom-status-change="handleBottomChange"
        :bottom-all-loaded="allLoaded"
        :auto-fill="false"
        ref="loadmore"
      >
        <ul class="mui-table-view" ref="ul">
          <li
            class="mui-table-view-cell mui-media"
            v-for="(item, taskIndex) in taskList"
            :key="taskIndex"
          >
            <router-link
              class="mui-navigate-right-route-link"
              :to="
                item.building.childbuildinglist.length > 0
                  ? '/Build/SecondBuild/' + item.id
                  : '/Build/buildDetail/' + item.id + '/' + item.building_id
              "
            >
              <div class="mui-media-left">
                <img
                  v-if="item.building.buildingimg"
                  class="mui-media-object mui-pull-left"
                  :src="
                    process.env.BASE_URL + item.building.buildingimg
                  "
                />
                <img
                  v-else
                  class="mui-media-object mui-pull-left"
                  src="/static/images/avatar.png"
                />
                <span
                  class="
                    mui-icon-extra
                    mui-icon-extra-peoples
                    mui-badge
                    mui-badge-primary
                  "
                  >{{ item.current }}</span
                >
              </div>
              <div class="mui-media-body">
                <div class="mui-media-body-first">
                  {{ item.building.name }}
                </div>
                <div class="mui-media-body-second">
                  <div class="mui-media-body-second-left">
                    {{ item.building.address }}
                  </div>
                  <div class="mui-media-body-second-right">
                    <a
                      :href="
                        'http://api.map.baidu.com/marker?location=' +
                        item.building.lat +
                        ',' +
                        item.building.lng +
                        '&title=' +
                        item.building.name +
                        '&content=' +
                        item.building.name +
                        '&output=html'
                      "
                      @click.stop
                    >
                      <img
                        src="/static/images/nav_icon.png"
                        alt=""
                        style="width: 14px"
                      />
                    </a>
                  </div>
                </div>
                <div class="mui-media-body-third">
                  <span
                    class="
                      mui-progressbar
                      mui-progressbar-danger
                      mui-media-body-third
                    "
                    data-progress="50"
                  >
                    {{ item.completerate }}%
                    <span
                      :style="
                        'transform: translate3d(-' +
                        (100 - item.completerate) +
                        '%, 0px, 0px); opacity: 0.6'
                      "
                    ></span>
                  </span>
                </div>
              </div>
              <div class="mui-media-right">
                <span
                  class="mui-icon mui-icon-plus mui-media-body-icon"
                  v-if="item.isjoin - 0 === 0"
                  @click.prevent="checkedBuild(taskIndex)"
                  ref="checkedBuildValue"
                ></span>
                <span
                  class="mui-icon mui-icon-minus mui-media-body-icon"
                  v-else
                  @click.prevent="checkedBuild(taskIndex)"
                  ref="checkedBuildValue"
                ></span>
              </div>
            </router-link>
          </li>
        </ul>
        <div v-if="allLoaded" style="text-align: center" class="data-none">
          没有更多数据了
        </div>
        <div class="loading-overlay" v-if="isLoading">
        <div class="loading-message">正在加载...</div>
      </div>
        <div
          v-if="bottomStatus === 'loading'"
          style="text-align: center"
          class="data-none"
        >
          <img src="/static/images/loading.gif" alt="" style="width: 25px" />
        </div>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span
            v-show="bottomStatus === 'drop'"
            :class="{ 'is-rotate': bottomStatus === 'drop' }"
            >↓</span
          >
          <span
            v-show="bottomStatus === 'pull'"
            :class="{ 'is-rotate': bottomStatus === 'pull' }"
            >↑</span
          >
        </div>
      </mt-loadmore>
    </div>
    <div class="loading-overlay" v-if="flag">
        <div class="loading-message">正在加载...</div>
      </div>
  </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui";
import {  getLocationWithB,getLocation, lib_getPosition } from '../../utils/getLocation'
export default {
  name: "HomeContainer.vue",
  data() {
    return {
      isLoading:false,
      flag:false,
      areaList: [
        {
          values: [
            {
              id: -1,
              name: "全部区域",
            },
          ],
        },
      ],
      area: "全部区域",
      areaPopupVisible: false,
      buildTypeList: [
        {
          values: [
            { id: 0, name: "建筑类型" },
            { id: 1, name: "行政服务中心" },
            { id: 2, name: "高铁站/火车站/汽车站" },
            { id: 3, name: "地铁站" },
            { id: 4, name: "大型停车场" },
            { id: 5, name: "综合医院/专科医院" },
            { id: 6, name: "博物馆/展览馆/艺术中心/剧院/音乐厅/科学馆" },
            { id: 7, name: "宾馆酒店" },
            { id: 8, name: "银行营业网点" },
            { id: 9, name: "景区" },
            { id: 10, name: "购物中心" },
            { id: 11, name: "残疾人之家" },
            { id: 12, name: "康复机构" },
            { id: 13, name: "机场" },
          ],
        },
      ],
      build: "全部",
      buildPopupVisible: false,
      rangeTypeList: [
        {
          values: [
            { id: 0, name: "距离选择" },
            { id: 1, name: "1公里之内" },
            { id: 2, name: "2公里之内" },
            { id: 3, name: "3公里之内" },
            { id: 4, name: "4公里之内" },
            { id: 5, name: "5公里之内" },
          ],
        },
      ],
      range: "距离选择",
      rangePopupVisible: false,
      buildType: 0,
      navIndex: 0,
      checkedBuildValue: false,
      title: "无障碍采集系统",
      searchValue: "",
      taskList: [],
      allLoaded: false,
      wrapperHeight: 0,
      offset: 0,
      limit: 6,
      InitialLoading: true,
      bottomStatus: "",
    };
  },
  created() {
    var areaList = localStorage.getItem('areaList');
    this.areaList[0].values = JSON.parse(areaList);
    this.$emit("getTitle", this.title);
    let phone = this.appSource();
    if (phone === 1) {
      this.wrapperHeight = document.documentElement.clientHeight - 124 - 50;
    } else {
      this.wrapperHeight = document.documentElement.clientHeight - 124;
    }
  },
  methods: {
    checkedBuild(taskIndex) {
      if (this.taskList[taskIndex].isjoin === "0") {
        MessageBox({
          title: "确认操作",
          message:
            "你确定选取" +
            this.taskList[taskIndex].building.name +
            "区域任务吗？该区域包含" +
            (this.taskList[taskIndex].building.childbuildinglist.length === 0
              ? 1
              : this.taskList[taskIndex].building.childbuildinglist.length) +
            "座建筑",
          showCancelButton: true,
        })
          .then((action) => {
            if (action === "confirm") {
              this.$http
                .get(
                  "api/gather/joinTask?task_id=" + this.taskList[taskIndex].id
                )
                .then((data) => {
                  if (data.body.code === 1) {
                    this.taskList[taskIndex].isjoin = "1";
                    this.taskList[taskIndex].current =
                      this.taskList[taskIndex].current + 1;
                    Toast("已加入该任务");
                  } else {
                    Toast(data.body.msg);
                  }
                });
            } else {
              this.taskList[taskIndex].isjoin = "0";
            }
          })
          .catch((error) => {
            if (error === "cancel") {
              this.taskList[taskIndex].isjoin = "0";
              this.$refs.checkedBuildValue.className =
                "mui-icon mui-icon-plus mui-media-body-icon";
            }
          });
      } else {
        MessageBox({
          title: "确认操作",
          message:
            "你确定放弃" +
            this.taskList[taskIndex].building.name +
            "区域任务吗？该区域包含" +
            (this.taskList[taskIndex].building.childbuildinglist.length === 0
              ? 1
              : this.taskList[taskIndex].building.childbuildinglist.length) +
            "座建筑",
          showCancelButton: true,
        })
          .then((action) => {
            if (action === "confirm") {
              this.$http
                .get(
                  "api/gather/exitTask?task_id=" + this.taskList[taskIndex].id
                )
                .then((data) => {
                  if (data.body.code === 1) {
                    this.taskList[taskIndex].isjoin = "0";
                    this.taskList[taskIndex].current =
                      this.taskList[taskIndex].current - 1;
                    Toast("已退出该任务");
                  } else {
                    Toast(data.body.msg);
                  }
                });
            } else {
              this.taskList[taskIndex].isjoin = "1";
            }
          })
          .catch((error) => {
            if (error === "cancel") {
              this.taskList[taskIndex].isjoin = "1";
            }
          });
      }
    },
    getpopupVisible(type) {
      document
        .getElementsByTagName("body")[0]
        .addEventListener("touchmove", this.handler, { passive: false });
      if (type === "area") {
        this.areaPopupVisible = true;
      } else if (type === "build") {
        this.buildPopupVisible = true;
      } else {
        this.rangePopupVisible = true;
      }
    },
    onAreaValuesChange(picker, values) {
      this.area = values[0].name;
      this.offset = 0;
      this.limit = 6;
      // this.getTaskList(this.offset, this.limit)
    },
    onBuildValuesChange(picker, values) {
      this.build = values[0].name;
      this.buildType = values[0].id;
      this.offset = 0;
      this.limit = 6;
      // this.getTaskList(this.offset, this.limit)
    },
    onRangeValuesChange(picker, values) {
      this.range = values[0].name;
    },
    addrConfirm(type) {
      document
        .getElementsByTagName("body")[0]
        .removeEventListener("touchmove", this.handler, { passive: false });
      if (type === "area") {
        this.areaPopupVisible = false;
      } else if (type === "build") {
        this.buildPopupVisible = false;
      } else {
        this.rangePopupVisible = false;
      }
      this.getTaskList(this.offset, this.limit);
    },
    getBuildingTypeList() {
      this.isLoading=true
      this.$http.get("api/gather/getBuildingTypeList").then(function (data) {
        this.buildTypeList[0].values = data.body.data.list;
        this.buildTypeList[0].values.unshift({ id: 0, name: "建筑类型" });
      });
      this.isLoading=false
    },
    getTaskList(offset, limit) {
      // console.log("isLoading")
      // this.flag=true
      let select = {
        offset: offset,
        limit: limit,
      };

      if (this.searchValue !== "") {
        select["name"] = this.searchValue;
      }

      if (this.area !== "全部区域") {
        select["area"] = this.area;
      }

      if (this.build !== "建筑类型") {
        select["buildingtype_id"] = this.buildType;
      }
      this.isLoading=true

      this.$http
        .post("api/gather/getTaskList", select, { emulateJSON: true })
        .then(function (data) {
          if (data.body.code === 1) {
            if (offset !== 0) {
              data.body.data.list.forEach((item, index) => {
                data.body.data.list[index].building.buildingimg =
                  item.building.buildingimg;
                this.taskList.push(data.body.data.list[index]);
              });
            } else {
              data.body.data.list.forEach((item, index) => {
                data.body.data.list[index].building.buildingimg =
                  item.building.buildingimg;
              });
              this.taskList = data.body.data.list;
            }
            if (data.body.data.count < this.limit && this.offset !== 0) {
              this.allLoaded = true;
            }
          } else {
            Toast(data.body.message);
          }
        }).finally((res)=>{
          this.isLoading=false
        });
        // this.flag=false
    },
    loadBottom() {
      this.flag=true
      this.offset += this.limit;
      this.handleBottomChange("loading");
      setTimeout(() => {
        this.getTaskList(this.offset, this.limit);
        this.handleBottomChange("loadingEnd");
      }, 1000);
      this.$refs.loadmore.onBottomLoaded();
      this.flag=false
    },
    handleBottomChange(status) {
      if (this.bottomStatus === "loading" && status === "pull") {
        this.bottomStatus = "loading";
      } else {
        this.bottomStatus = status;
      }
    },
    appSource() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        return 1;
      } else {
        return 2;
      }
    },
  },
  mounted() {
    // this.getBuildingTypeList();
    // console.log("高德地图现状,有时候会报错")
    // getLocation()
    // console.log("百度地图定位，好像比较稳定")
    // lib_getPosition()
    // getLocationWithB()

     
    this.getTaskList(this.offset, this.limit);
  },
  watch: {
    searchValue(n) {
      this.offset = 0;
      this.limit = 6;
      console.log("abcd720210")
      this.isLoading=true
      this.getTaskList(this.offset, this.limit);
      this.isLoading=false
    },
  },
};
</script>

<style scoped lang="scss">
.mint-swipe {
  height: 178.5px;

  .mint-swipe-item {
    img {
      width: 100%;
    }
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 18px;
}
.mui-table-div {
  overflow-x: auto;
  overflow-y: scroll;
  margin-bottom: 50px;
  -webkit-overflow-scrolling: touch;
  display: block;

  .mui-table-view {
    .mui-table-view-cell {
      height: 100px;

      .mui-navigate-right-route-link {
        height: 100px;

        .mui-media-left {
          width: 40px;
          height: 78px;
          display: inline-block;
          text-align: center;
          float: left;

          img {
            width: 100%;
          }

          span {
            width: 40px;
            text-align: center;
            font-size: 16px;
            margin: 10px auto;
          }
        }

        .mui-media-body {
          width: calc(100% - 110px);
          display: inline-block;
          padding-left: 20px;
          height: 78px;
          float: left;

          .mui-media-body-first {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 28px;
            font-size: 20px;
          }

          .mui-media-body-second {
            width: 100%;

            .mui-media-body-second-left {
              max-width: 90%;
              display: inline-block;
              font-size: 14px;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .mui-media-body-second-right {
              max-width: 10%;
              display: inline-block;
            }
          }

          .mui-media-body-third {
            height: 22px;
            display: inline-block;
            float: left;
            width: 100%;
            text-align: center;
          }
        }

        .mui-media-right {
          width: 60px;
          float: right;
          height: 78px;
          .mui-icon {
            font-size: 36px;
            display: inline-block;
            margin: 21px 0 0 18px;
          }
        }
      }
    }
  }
}

.mint-header {
  background: #fff;
  color: #666;
  font-size: 16px;
}

.mint-popup {
  width: 100%;
  .picker {
    width: 100%;
    .picker-items {
      width: 100%;
      .picker-slot.picker-slot-center {
        width: 100%;
      }
    }
  }
}

.picker-toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #f5f5f5;
}

.usi-btn-cancel,
.usi-btn-sure {
  color: #108ee9;
}

.mui-icon-arrowleft {
  display: block;
  float: left;
  padding-top: 13px;
}

.mui-icon-arrowright {
  display: block;
  float: right;
  padding-top: 13px;
}

.mint-search {
  height: 40px;
  padding: 0;

  .mint-searchbar {
    padding: 0;
  }
}

.mint-searchbar-inner {
  padding: 0;
  height: 60px;
}

.mint-searchbar {
  padding: 0;
}

.mint-searchbar-cancel {
  height: 50px;
  line-height: 40px;
  background: white;
  margin: 0;
  padding: 5px;
}

.mint-switch {
  display: inline-block;
}

.mui-badge,
.mui-badge-primary {
  float: left;
  margin-top: 10px;
  font-size: 14px;
}

#app {
  padding-top: 70px;
  margin-bottom: 30px;
}

.select-home-class {
  //height: 30px;
  //position: fixed;
  //z-index: 1;
  //width: 100%;
  //top: 80px;
  //background-color: white;
}
.module-list-wrap {
  display: inline-block;
  width: 49%;
  font-size: 16px;
  line-height: 26px;
  height: 30px;
  border: 2px solid #ccc;
  text-align: center;
  overflow: hidden;
  padding: 2px;
  text-overflow: ellipsis;
  white-space: nowrap; //溢出不换行
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar/HomeContainer.vue